// モバイル端末 (スマホ等の小画面 / タッチ環境) 判定。
// 起動時に各ロゴで GUI を自動 close したり、HUD のレイアウトを切り替えるのに使う。
//
// 判定基準:
//   - viewport 幅 ≤ 768px (CSS のモバイルブレイクポイント)
//   - もしくは UA に Mobi/Android/iPhone を含む
// どちらかを満たせばモバイル扱い。
export function isMobile(): boolean {
  if (typeof window === "undefined") return false;
  const narrow = window.matchMedia("(max-width: 768px)").matches;
  const uaMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  return narrow || uaMobile;
}
